module.exports = __webpack_public_path__ + "assets/configuration-simple-icon.d1544fdd.svg";